import React, { useState, useEffect } from 'react';
import { Modal } from 'rsuite';
import CoreTextArea from '../CoreTextArea';
import CommonAlert from '../CommonAlert';
import { toast } from 'react-toastify';
import useApiManager from 'networking/ApiManager';
function AppointmentDescription(props) {
  console.log("=-=-=--=-",props)
  const { appointmentDetail, sessionNotes, setSessionNotes, cancelModal, setCancelModal, handleCancelAppointment, isShowAlert, setIsShowAlert, alertType, errors, data } = props;
  const [overflow, setOverflow] = useState(true);
  const [specialitynotes, setSpecialitynotes] = useState('')
  const ApiClient = useApiManager()
  useEffect(() => {
    if (cancelModal && data && data[0]) {
      setSpecialitynotes(data[0]);
    }
  }, [cancelModal, data]);

  const upddateNotesBySpec = (id, data) => {
    const payload = {
      notes_by_speciality: specialitynotes, // 👈 key matches backend field
    };
    ApiClient.updateNotesSpec(id, payload)
      .then((res) => {
        if (res.status == 200) {
          setCancelModal(false)
          toast.success('Notes Updated Successfully')
        }
        else {
          toast.error("Something Went Wrong")
        }
      })
      .catch((err) => {
        console.log(err)
        toast.error('Internal Server Error')
      })
  }
  return (
    <>
      <Modal
        className='recordPayment'
        backdrop='static'
        overflow={overflow}
        open={cancelModal}
        onClose={() => setCancelModal(false)} // shows cross and closes modal
      >
        <Modal.Header>
          <Modal.Title className='text-center modalTitle'> Appointment Description</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={`${isShowAlert ? 'mt-5' : ''}`}>
            <CommonAlert isShowAlert={isShowAlert} alertType={alertType} setIsShowAlert={setIsShowAlert} />
          </div>
          <div className='appontmentModle-body d-flex flex-column'>
            <div className='mb-2'>
              <div className='mb-2'>
                <CoreTextArea
                  retuired
                  label={'Notes by Speciality'}
                  placeholder={'Enter notes for this session (max 255 characters)'}
                  // value={specialitynotes}
                  value={sessionNotes[data[1]] ?? specialitynotes ?? data[0]}
                  setValue={(val) => {
                    if (val.length <= 255) {
                      setSpecialitynotes(val)
                    }
                    setSessionNotes((prev) => ({
                      ...prev,
                      [data[1]]: val
                    }));
                  }}
                  rows={4}
                  maxLength={255}
                />
                <div style={{ marginTop: '5px', textAlign: 'right', fontSize: '12px', }}>
                  {specialitynotes.length}/255 characters
                </div>
              </div>
            </div>
            <div className='mb-2 mt-3'>
              <div
                className='d-flex justify-content-between gap-10 schedulButton'
                onClick={() => {
                  upddateNotesBySpec(data[1], specialitynotes);
                }}
              >
                <div className='reusableBtnActive  reusableBtn  w-100'>Update Notes By Speciality</div>
              </div>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AppointmentDescription;